import { OPTIMIZELY_FLAGS_ENUM } from 'src/constants'
import { useOptimizelyDecisionsContext } from 'src/context/optimizely-decisions-context'

export interface ImagePerformanceExperimentVariables {
  config: {
    preconnect: boolean
    numberImagesFetchPriorityHigh: number
    numberImagesPriority: number
    numberImagesToEagerLoad: number
  }
}
export const defaultImagePerformanceExperimentVariables = {
  config: {
    preconnect: false,
    numberImagesFetchPriorityHigh: 0,
    numberImagesPriority: 0,
    numberImagesToEagerLoad: 0,
  },
}

export const getImagePerformanceExperimentVariables =
  (): ImagePerformanceExperimentVariables => {
    const optiContext = useOptimizelyDecisionsContext()

    return (
      (optiContext?.getExperimentVariables(
        OPTIMIZELY_FLAGS_ENUM.AGE_SEARCH_IMAGE_PERFORMANCE,
      ) as unknown as ImagePerformanceExperimentVariables) ??
      defaultImagePerformanceExperimentVariables
    )
  }
